module.exports = __webpack_public_path__ + "img/wx-qcode.6677e50a.png";